import { Component, OnInit, Input } from '@angular/core';

import { ManagerIFace } from 'src/app/shared/classes';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-manager-show',
  templateUrl: './manager-show.component.html',
  styleUrls: ['./manager-show.component.less']
})
export class ManagerShowComponent implements OnInit {
  @Input() manager: ManagerIFace;

  public showManager = true;

  public managerInfo = {
     fullName : '',
     admin_id : '',
     email:'',
     mobile: '',
     country:'',
     organisation:'',
     admin_type:'',
     plan_model:'',
     sub_account_type:'',
     sub_account_limit:'',
     license_type:'',
     status:'',
     start_date:'',
     expire_date:'',
     permission_level:'',
     hosting:''
    // tier:''
  };

  constructor(private util: UtilsService) { }

  ngOnInit() {
    this.setUpUserData();
  }

  // sets up the user info data to the show form
  private setUpUserData() {
        this.managerInfo.fullName = this.manager.data['name'];
        this.managerInfo.admin_id = this.manager.data['admin_id'];
        this.managerInfo.email = this.manager.data['email'];
        this.managerInfo.mobile = this.manager.data['mobile'];
        this.managerInfo.country =  this.manager.data['country'];
        this.managerInfo.organisation = this.manager.data['organisation'];
        this.managerInfo.admin_type = this.reconvertCodeType("adminType",this.manager.data['admin_type']);
        this.managerInfo.plan_model = this.reconvertCodeType("planModel",this.manager.data['plan_model']);
        this.managerInfo.sub_account_type = this.manager.data['sub_account_type'];
        this.managerInfo.sub_account_limit = this.manager.data['sub_account_limit'];
        this.managerInfo.license_type = this.manager.data['license_type'];
        this.managerInfo.status = this.manager.data['status'];
        this.managerInfo.start_date = this.manager.data['start_date'];
        this.managerInfo.expire_date = this.manager.data['expire_date'];
        this.managerInfo.permission_level = this.manager.data['permission_level'];
        this.managerInfo.hosting = this.manager.data['hosting'];
       // this.managerInfo.tier = this.manager.data['tier'];
        
        this.showManager = true;
      }

  
      private reconvertCodeType(type,value){
        let output = "";
        switch(type){
            case "adminType":
               if(value == "ECO"){
                 output = "Ecosystem";
                 return output;
               }
               if(value == "P"){
                  output = "Provider";
                  return output;
               }
            break;
            case "planModel":
               if(value == "ECO-B"){
                  output = "Ecosystem Beginner";
                  return output;
               }
               if(value == "ECO-D"){
                  output = "Ecosystem Developer"
                  return output;
               }
               if(value == "ENTP-B"){
                  output = "Enterpise Premise Beginner";
                  return output;
               }
               if(value == "ENTP-D"){
                  output = "Enterprise Premise Developer";
                  return output;
               }
               if(value == "ENTC-B"){
                output = "Enterpise Cloud Beginner";
                return output;
               }
               if(value == "ENTC-D"){
                output = "Enterprise Cloud Developer";
                return output;
               }
            break;
        }
       }
 }
      
